import { render, staticRenderFns } from "./CellBoard.vue?vue&type=template&id=55dc0640&scoped=true&"
import script from "./CellBoard.vue?vue&type=script&lang=js&"
export * from "./CellBoard.vue?vue&type=script&lang=js&"
import style0 from "./CellBoard.vue?vue&type=style&index=0&id=55dc0640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc0640",
  null
  
)

export default component.exports